export const DashboardId = "Dashboard";
export const ReportsId = "Reports";
export const RevenueId = "Revenue";
export const ExpensesId = "Expenses";
export const EmployeesId = "Employees";
export const SalariesId = "Salaries";
export const DeviationsId = "Deviations";
export const WintDeviationsId = "WintDeviations";
export const CommissionsId = "Commissions";
export const SupportId = "Support";
export const SettingsId = "Settings";
export const IncomingInvoicesId = "IncomingInvoices";
export const InvoicesId = "Invoices";
export const ReceiptsId = "Receipts";
export const RecurringInvoicesId = "RecurringInvoices";
export const CashReconciliationsId = "CashReconciliations";
export const BusinessUnitsId = "BusinessUnits";
export const TimeReportingProjectsId = "TimeReportingProjects";
export const AdvisoryViewId = "AdvisoryView";
export const SalarySpecificationsId = "SalarySpecifications";
export const BenefitsId = "Benefits";
export const WintSalariesId = "WintSalaries";
